module.exports = __webpack_public_path__ + "img/yuhongshan.88c11f1e.png";